import React, { useCallback } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "scmp-sdk/components/rosetta/hooks";
import type { GA4Event } from "scmp-sdk/lib/google-analytics/ga4-types";

import { StyledAlertIcon, StyledSubscriptionButton } from "./styles";

type Props = {
  className?: string;
};
export const GracePeriodButton: React.FunctionComponent<Props> = ({ className }) => {
  const { config, handleTrackGA4 } = useSdkContext();
  const { computeGA4CommonParameters } = useGA4CommonParameters();

  const { captureTrackImpressionEventTargetElement } = useSendImpressionEvents({
    ga4Event: useCallback<() => GA4Event>(
      () => ({
        action: "imp",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "update payment",
          trigger_point: "masthead grace period renewal failure banner",
        },
        subcategory: "entry_point",
      }),
      [computeGA4CommonParameters],
    ),
  });

  return (
    <StyledSubscriptionButton
      className={className}
      onClick={() => {
        handleTrackGA4({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...computeGA4CommonParameters(),
            call_to_action: "update payment",
            trigger_point: "masthead grace period renewal failure banner",
          },
          subcategory: "entry_point",
        });

        globalThis.location.href = `${config.accounts.host}/settings`;
      }}
      ref={captureTrackImpressionEventTargetElement}
    >
      <StyledAlertIcon />
      Renewal Failed
    </StyledSubscriptionButton>
  );
};

GracePeriodButton.displayName = "GracePeriodButton";
